export {
  default as getCommonUserContext,
  getContextForCurrentPlatform,
  getContextForPlatform,
} from './src/commonContext';

export {
  setActingUser,
  clearActingUser,
  isActingAsUser,
  getActingUserToken,
  getActingUserRefId,
  getTokenExpiry,
} from './src/actingUserContext';
